export const data = {
  DEPLOYMENT_ENV: 'development',
  NEXT_PUBLIC_GTM_ID: "GTM-TPFGGLT",
  NEXT_PUBLIC_SITE_MACHINE_NAME: 'construction',
  NEXT_PUBLIC_CF_RC_SPACE_ID: 'jnzexz4x7lkk',
  NEXT_PUBLIC_CF_RC_ENVIRONMENT: 'master',
  NEXT_PUBLIC_RC_TYPE: 'blog',
  NEXT_PUBLIC_RENDER_NAV: true,
  NEXT_PUBLIC_RENDER_FOOTER: true,
  NEXT_PUBLIC_PRERENDER_ARTICLES: true,
  NEXT_PUBLIC_PRERENDER_CASESTUDIES: true,
  NEXT_PUBLIC_PRERENDER_DOCS: true,
  NEXT_PUBLIC_PRERENDER_VIDEOS: true,
  NEXT_PUBLIC_DATA_REVALIDATION: false,
  NEXT_PUBLIC_DATA_REVALIDATION_SECONDS: 0,
  NEXT_PUBLIC_PREVIEW_DATA: true,
  NEXT_PUBLIC_GTM_DISABLE: true,
  NEXT_PUBLIC_ONETRUST_DISABLE: true,
  NEXT_PUBLIC_ONETRUST_ID: "c4b867da-0106-4cc2-85ba-b4958ea10d7e",
  NEXT_PUBLIC_ALGOLIA_APP_ID: "BGUNL6UMZR",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "trimble-rc-construction",
  NEXT_PUBLIC_ALGOLIA_API_KEY: "d391b07b54d358a1351edb9a348b4a75",
  NEXT_PUBLIC_ALGOLIA_SEARCH_HITS_PER_PAGE: 10,
  BASE_URL: 'https://const-trmb-rc-b-draft.netlify.app',
  NAV_BASE_URL: 'https://www.trimble.com',
  SHOW_UNPUBLISHED_NAV: true,
  SECURE_SITE: false,
  SECURE_SITE_PASS: "trimble",
  SECURE_SITE_PASS_HASH: "wuv6zfn0BDU!aty0fyx"
}
